import { doc, getDoc, setDoc } from 'firebase/firestore'

import { db } from 'utils/firebase'

import { WorkoutTag } from 'types/workoutTag'

import { formatDocSnapshot } from './formatFirestoreResults'

import workoutTagsData from '../workoutTags.json'

export const fetchWorkoutTags = async (): Promise<WorkoutTag> => {
  const docRef = doc(db, '_admin', 'workoutTags')
  const result = await getDoc(docRef)
  return formatDocSnapshot<WorkoutTag>(result)
}

export const postWorkoutTags = async () => {
  const docRef = doc(db, '_admin', workoutTagsData.id)
  await setDoc(docRef, { tagGroups: workoutTagsData.tagGroups })
}
